export default __webpack_public_path__ + "static/media/Madison Fernandez - Vice President.b1d9c5d0.jpg";